import { __decorate } from "tslib";
import { css, html, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
/**
 * The AG Editable Renderer element.
 * @public
 * @tagname %%prefix%%-editable-renderer
 */
export class EditableRenderer extends FoundationElement {
    init(params) {
        if (!params)
            return;
        this.valueFormatted = params.formatValue(params.value);
    }
    getGui() {
        return this;
    }
    refresh(params) {
        this.valueFormatted = params.formatValue(params.value);
        return true;
    }
}
__decorate([
    observable
], EditableRenderer.prototype, "valueFormatted", void 0);
/**
 * The AG Editable Renderer Styles.
 * @public
 */
export const agEditableRendererStyles = css `
  :host {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
/**
 * Get a Design System prefixed Checkbox template.
 * @param designSystem - The design system prefix to use. Defaults to 'foundation'.
 * @returns A Checkbox component template prefixed with the correct design system.
 * @public
 */
export const getAgEditableRendererTemplate = (designSystem = 'foundation') => {
    return html `
    <span>${(x) => x.valueFormatted}</span>
    <${designSystem}-progress-ring style="margin: 0; width: 20px; height: 20px"></${designSystem}-progress-ring>
  `;
};
/**
 * A function that returns a Foundation Editable Renderer registration for configuring the component with a DesignSystem.
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-editable-renderer\>
 */
export const foundationAgEditableRenderer = EditableRenderer.compose({
    baseName: 'editable-renderer',
    styles: agEditableRendererStyles,
    template: getAgEditableRendererTemplate(),
});
